import { useTranslation } from 'react-i18next'
import './Opinions.css'

function Opinions() {

    const { t } = useTranslation()

    return (
        <section className="container-lg d-flex flex-column gap-4 opinions">
            <div className="d-flex flex-column flex-sm-row opinions-panel" data-aos="fade-zoom-right" data-aos-delay="100">
                <div className='d-flex align-items-center justify-content-center opinions-panel__title'>
                    <h3 className='m-0 text-center'>{t("opinions.header1.title")}</h3>
                </div>
                <div className='d-flex align-items-center justify-content-center opinions-panel__text'>
                    <p className='m-0'>{t("opinions.header1.message")}</p>
                </div>
            </div>
            <div className="d-flex flex-column flex-sm-row opinions-panel" data-aos="fade-zoom-left" data-aos-delay="200">
                <div className='d-flex align-items-center justify-content-center opinions-panel__title'>
                    <h3 className='m-0 text-center'>{t("opinions.header2.title")}</h3>
                </div>
                <div className='d-flex align-items-center justify-content-center opinions-panel__text'>
                    <p className='m-0'>{t("opinions.header2.message")}</p>
                </div>
            </div>

            <div className="d-flex flex-column flex-sm-row opinions-panel" data-aos="fade-zoom-right" data-aos-delay="300">
                <div className='d-flex align-items-center justify-content-center opinions-panel__title'>
                    <h3 className='m-0 text-center'>{t("opinions.header3.title")}</h3>
                </div>
                <div className='d-flex align-items-center justify-content-center opinions-panel__text'>
                    <p className='m-0'>{t("opinions.header3.message")}</p>
                </div>
            </div>

            <div className="d-flex flex-column flex-sm-row opinions-panel" data-aos="fade-zoom-left" data-aos-delay="400">
                <div className='d-flex align-items-center justify-content-center opinions-panel__title'>
                    <h3 className='m-0 text-center'>{t("opinions.header4.title")}</h3>
                </div>
                <div className='d-flex align-items-center justify-content-center opinions-panel__text'>
                    <p className='m-0'>{t("opinions.header4.message")}</p>
                </div>
            </div>
        </section>
    )

}

export default Opinions